import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Footer from "./components/Footer/Footer";
import Time from "./pages/Time";

import CamisaDetalhe from "./pages/CamisaDetalhe";

import "./styles.css";
import Busca from "./pages/Busca";
import Dashboard from "./pages/Dashboard";
import SelecaoBrasileira from "./pages/SelecaoBrasileira";
import TimeEuropa from "./pages/TimeEuropa";
import CopaDoMundo from "./pages/CopaDoMundo";
import SizeGuide from "./pages/SizeGuide";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />

      <main>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/selecao-brasileira" element={<SelecaoBrasileira />} />
          <Route path="/copa-do-mundo" element={<CopaDoMundo />} />
          <Route path="/:pais/:liga/:time" element={<Time />} />
          <Route path="/guia-tamanhos" element={<SizeGuide />} />
          <Route path="/europa/:time" element={<TimeEuropa />} />{" "}
          <Route path="/camisa/:id" element={<CamisaDetalhe />} />
          <Route path="/buscar" element={<Busca />} />
        </Routes>
      </main>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
